import type { FaireProductEntity } from "../../entity_types/product";

export const p_6mfegveu5a: FaireProductEntity = {
  token: "p_6mfegveu5a",
  type: "product",
  name: "LE GRAND OJAI NUIT",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl: "https://cdn.faire.com/fastly/f68b85fc391cdeaa04384cb11faa48dc69f8b5dd3de74fed6fbb31f538a86b20.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7584ca8e3dda8c5e9e1715bc70e9b006bf7e6abd16ecb6071d132fd59afdf112.jpeg",
    "https://cdn.faire.com/fastly/3127e6143aaa1d0c3638408ad62112ae100bd7eb381536a77c6d6920056b36e3.jpeg",
    "https://cdn.faire.com/fastly/49c74fde8f08898b8924dff27687b0258ebc08e667534d42db5bae77ca4a2c98.jpeg",
    "https://cdn.faire.com/fastly/ff381b0b08db778c2a5f4eae8916f89b3fd0cebd069c4b016a5af6255d34c9ec.jpeg",
    "https://cdn.faire.com/fastly/558d98707c634407687977754de427f632e734ec243738afa3fce8c7a5f3be15.jpeg"
  ],
  priceDollars: 30,
  description: "Le Grand Ojai Nuit, 14 oz of your favorite scent!\n\nReminiscent of a summer getaway spent in Ojai, this scent will transport you to a night under the stars with the clean scent of balsam fir and sandalwood balanced beautifully with airy top notes of fresh fig tree.\n\nbalsam fir, fig leaf, sandalwood, amber\n\nRoen candles are hand poured in our Southern California studio using a coconut + soy wax blend for a natural, clean burn. We use lead-free cotton wicks and premium fragrance oils. All of our candles are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials.\n\n14 ounces (397g), comes in our signature pink box.",
  tags: [],
  msrpDollars: 60,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:05:10.558Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
